import React from 'react'
import { ActionIcon, Flex, Group, Loader, Paper, Stack, Text, useMantineTheme } from '@mantine/core'
import { IconPencil, IconTrash } from '@tabler/icons-react'

/**
 * Display-only. A goal now carries a name and a description, which is more than
 * an inline row can edit, so both are edited in GoalModal.
 */
const GoalItem = ({ goal, onEdit, onDelete, isDeleting = false }) => {
  const theme = useMantineTheme()

  return (
    <Paper radius="md" p="sm" bg={theme.colors.gray[0]}>
      <Flex justify="space-between" align="flex-start" gap="sm" wrap="nowrap">
        {/* Same minWidth: 0 rule as the card header — a long goal name must
            wrap inside its own column, not shove the icons out of the row. */}
        <Stack spacing={2} sx={{ flex: 1, minWidth: 0 }}>
          <Text
            onClick={onEdit}
            sx={{ cursor: 'pointer', overflowWrap: 'anywhere' }}
            lineClamp={2}
          >
            {goal.name}
          </Text>
          {goal.description && (
            <Text size="xs" c="dimmed" lineClamp={2} sx={{ overflowWrap: 'anywhere' }}>
              {goal.description}
            </Text>
          )}
        </Stack>
        <Group spacing={4} noWrap sx={{ flexShrink: 0 }}>
          <ActionIcon variant="subtle" onClick={onEdit} aria-label="Edit goal">
            <IconPencil size={16} />
          </ActionIcon>
          <ActionIcon color="red" variant="subtle" onClick={onDelete} aria-label="Delete goal" disabled={isDeleting}>
            {isDeleting ? <Loader size="xs" /> : <IconTrash size={16} />}
          </ActionIcon>
        </Group>
      </Flex>
    </Paper>
  )
}

export default GoalItem
